import { notificationApi as api } from './notificationApi';

export const addTagTypes = ['Notifications'] as const;

export type NotificationMeta = {
  pageUrl?: string;
  kind?: string;
  contentType?: string;
  count?: number;
  actorName?: string;
  profileImage?: string;
  [key: string]: any;
};

export type NotificationItem = {
  id: string;
  userId: string;
  header?: string;
  content?: string;
  meta?: NotificationMeta;
  read?: boolean;
  status?: string;
  notificationTypeId?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type GetNotificationsApiResponse = {
  ok: boolean;
  data: {
    rows: NotificationItem[];
    count: number;
    unreadCount: number;
    page: number;
    limit: number;
  };
  message: string;
};
export type GetNotificationsApiArg = {
  page?: number;
  limit?: number;
};

export type GetUnreadCountApiResponse = {
  ok: boolean;
  data: { count: number };
  message: string;
};
export type GetUnreadCountApiArg = void;

export type MarkNotificationReadApiResponse = {
  ok: boolean;
  data: { success: boolean };
  message: string;
};
export type MarkNotificationReadApiArg = { id: string };

const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getNotifications: build.query<
        GetNotificationsApiResponse,
        GetNotificationsApiArg
      >({
        query: queryArg => ({
          url: `/notifications`,
          params: {
            page: queryArg.page,
            limit: queryArg.limit
          }
        }),
        providesTags: ['Notifications']
      }),
      getUnreadNotificationCount: build.query<
        GetUnreadCountApiResponse,
        GetUnreadCountApiArg
      >({
        query: () => ({ url: `/notifications/unreadCount` }),
        providesTags: ['Notifications']
      }),
      markNotificationRead: build.mutation<
        MarkNotificationReadApiResponse,
        MarkNotificationReadApiArg
      >({
        query: queryArg => ({
          url: `/notifications/${queryArg.id}/read`,
          method: 'PATCH'
        }),
        invalidatesTags: ['Notifications']
      })
    }),
    overrideExisting: false
  });

export { injectedRtkApi as notificationInjectedApi };

export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useGetUnreadNotificationCountQuery,
  useMarkNotificationReadMutation
} = injectedRtkApi;
